__turbopack_context__.v({
  "bgImage": "riArca_bgImage",
  "bgImageFullScreen": "riArca_bgImageFullScreen",
  "bgWrapper": "riArca_bgWrapper",
  "bgWrapperFullScreen": "riArca_bgWrapperFullScreen",
  "childrenWrapper": "riArca_childrenWrapper",
  "errorPageWrapperFullScreen": "riArca_errorPageWrapperFullScreen",
  "eveLogoContainer": "riArca_eveLogoContainer",
  "heading": "riArca_heading",
  "mainContainer": "riArca_mainContainer",
  "paragraph": "riArca_paragraph",
  "textContainer": "riArca_textContainer",
});
